/* ================================================================
   Sophie Conran — Nadia mobile bottom bar + attention grabber
   ================================================================
   Two modes controlled by scrolling past the inline catalogue CTA:
     "bar"   → fixed bottom strip with SOFA CATALOGUE REQUEST + N
     "float" → bar disappears, N floats alone in the bottom-right
   ================================================================ */

(function () {
  'use strict';

  if (window.innerWidth > 768) return;

  var POPUP_DELAY = 5000;
  var STORAGE_KEY = 'sc_nadia_popup_dismissed';
  var bar = document.getElementById('sc-nadia-bar');
  var popup = document.getElementById('sc-nadia-popup');
  var closeBtn = document.getElementById('sc-nadia-popup-close');
  var launcher = document.getElementById('sc-nadia-bar-launcher');

  if (!bar) return;

  /* ── Page type detection ── */
  var path = window.location.pathname.toLowerCase().replace(/\/+$/, '');
  /* Homepage: '/', '', or a market-prefixed root like '/en-us' */
  var isHomepage = path === '' || /^\/[a-z]{2}(-[a-z]{2})?$/.test(path);
  var isGallery = path.indexOf('/pages/gallery') !== -1;
  var isFullVariant = isHomepage || isGallery;

  /* Bar mode on the homepage only. Everywhere else, float from the start
     so there is never a flash of the bar before the mode is set. */
  bar.setAttribute('data-mode', isHomepage ? 'bar' : 'float');
  if (popup) popup.setAttribute('data-mode', isHomepage ? 'bar' : 'float');

  /* ── Scroll-away: switch between bar and float ──
     The bar (catalogue CTA + Nadia) is homepage only. Everywhere else
     it is the floating Nadia widget alone, with no bar chrome.
     On the homepage, bar mode holds until the inline catalogue CTA
     has scrolled off the top, then float mode takes over. */
  var inlineCtas = [];

  /* Containers whose links should never count as the page CTA */
  var EXCLUDED_ANCESTORS = 'header, footer, nav, [role="navigation"], ' +
    '.sc-header, .sc-footer, .sc-drawer, .drawer, .menu-drawer, ' +
    '[class*="nav"], [class*="menu"], [class*="drawer"]';

  function findInlineCtas() {
    var candidates = document.querySelectorAll('a, button');
    var found = [];

    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (bar.contains(el)) continue;

      var text = (el.textContent || '').trim().toLowerCase();
      var isCtaText = text.indexOf('catalogue request') !== -1 ||
                      text.indexOf('sofa catalogue') !== -1 ||
                      text.indexOf('request a catalogue') !== -1 ||
                      text.indexOf('request the catalogue') !== -1;
      if (!isCtaText) continue;

      if (el.closest(EXCLUDED_ANCESTORS)) continue;
      if (!el.offsetParent) continue;
      var rect = el.getBoundingClientRect();
      if (rect.width === 0 || rect.height === 0) continue;

      found.push(el);
    }
    return found;
  }

  function updateMode() {
    /* Off the homepage: always float, never show the bar */
    if (!isHomepage) return;

    var stillAhead = false;
    for (var i = 0; i < inlineCtas.length; i++) {
      if (inlineCtas[i].getBoundingClientRect().bottom > 0) {
        stillAhead = true;
        break;
      }
    }

    var mode = stillAhead ? 'bar' : 'float';
    if (bar.getAttribute('data-mode') !== mode) {
      bar.setAttribute('data-mode', mode);
      if (popup) popup.setAttribute('data-mode', mode);
    }
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      updateMode();
      ticking = false;
    });
  }

  function setupScrollCollapse() {
    if (!isHomepage) return;
    inlineCtas = findInlineCtas();
    /* Uncomment to debug which element is being tracked:
       console.log('[sc-nadia-bar] tracking', inlineCtas.length, 'CTA(s)', inlineCtas); */
    updateMode();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  setTimeout(setupScrollCollapse, 500);

  /* ── Show the right popup variant ── */
  var fullContent = document.getElementById('sc-nadia-popup-full');
  var compactContent = document.getElementById('sc-nadia-popup-compact');

  if (popup && fullContent && compactContent) {
    if (isFullVariant) {
      fullContent.style.display = 'block';
      compactContent.style.display = 'none';
      popup.classList.add('sc-nadia-popup--full');
      popup.classList.remove('sc-nadia-popup--compact');
    } else {
      fullContent.style.display = 'none';
      compactContent.style.display = 'block';
      popup.classList.add('sc-nadia-popup--compact');
      popup.classList.remove('sc-nadia-popup--full');
    }
  }

  /* ── Popup timing ── */
  function showPopup() {
    if (!popup) return;
    if (sessionStorage.getItem(STORAGE_KEY)) return;
    popup.style.display = 'block';
    void popup.offsetHeight;
    popup.setAttribute('data-visible', 'true');
  }

  function dismissPopup() {
    if (!popup) return;
    popup.setAttribute('data-visible', 'false');
    sessionStorage.setItem(STORAGE_KEY, '1');
    setTimeout(function () {
      popup.style.display = 'none';
    }, 400);
  }

  setTimeout(showPopup, POPUP_DELAY);

  if (closeBtn) {
    closeBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      dismissPopup();
    });
  }

  document.addEventListener('click', function (e) {
    if (!popup || popup.getAttribute('data-visible') !== 'true') return;
    if (popup.contains(e.target)) return;
    if (launcher && launcher.contains(e.target)) return;
    dismissPopup();
  });

  /* ── Launcher: open chat ── */
  if (launcher) {
    launcher.addEventListener('click', function () {
      dismissPopup();
      /* The bar hides via the 'nadia:open' event fired by openPanel() */
      if (window.SCNadia && window.SCNadia.open) {
        window.SCNadia.open();
      } else {
        /* Panel API not ready — hide the bar anyway so it doesn't linger */
        bar.setAttribute('data-hidden', 'true');
      }
    });
  }

  /* ── Restore bar/float when chat closes ── */
  /* The panel uses class 'open' (added/removed by openPanel/closePanel
     in nadia-floating-panel.js). Watch for that class being removed. */
  /* ── Show/hide the bar as the chat panel opens and closes ──
     Primary mechanism: explicit events dispatched by
     nadia-floating-panel.js. The MutationObserver below is a fallback
     in case the panel script is an older version without the events. */
  document.addEventListener('nadia:open', function () {
    bar.setAttribute('data-hidden', 'true');
  });

  document.addEventListener('nadia:close', function () {
    bar.setAttribute('data-hidden', 'false');
  });

  function watchPanelClose() {
    var panel = document.getElementById('nadia-panel');
    if (!panel) {
      /* Panel is created lazily — keep retrying until it exists */
      setTimeout(watchPanelClose, 500);
      return;
    }
    var obs = new MutationObserver(function () {
      bar.setAttribute('data-hidden',
        panel.classList.contains('open') ? 'true' : 'false');
    });
    obs.observe(panel, { attributes: true, attributeFilter: ['class'] });
  }
  watchPanelClose();

})();
